export default (ary1, ary2) => JSON.stringify(ary1) === JSON.stringify(ary2);
